import { Component, inject, OnInit } from '@angular/core';
import { MagicSearchService } from '../creators/service/magic-search/magic-search.service';
import { CollaboratorService } from '../../services/collaborator/collaborator.service';
import { TooltipDirective } from '../../common/directives/tooltip/tooltip.directive';
import { ForYouCreatorsComponent } from './molecules/for-you-creators/for-you-creators.component';
import { MagicFiltersComponent } from '../creators/molecules/magic-filters/magic-filters.component';
import { FilteredCreatorsComponent } from './molecules/filtered-creators/filtered-creators.component';
import { MagicSearchbarV2Component } from '../creators/molecules/magic-searchbar-v2/magic-searchbar-v2.component';
import { SearchedCreatorsComponent } from './molecules/searched-creators/searched-creators.component';
import { CreatorCardBlueComponent } from '../creators/molecules/creator-card-blue/creator-card-blue.component';
import { CollaboratorsComponent } from '../creators/molecules/collaborators/collaborators.component';
import { CreatorProfileComponent } from '../creators/molecules/creator-profile/creator-profile.component';
import { SocialScreeningService } from '../../services/social-screening/social-screening.service';
import { CreatorsForListComponent } from '../screening-briefs/molecules/creators-for-list/creators-for-list.component';
import { SingleVideoViewerSummaryComponent } from '../../atoms/single-video-viewer-summary/single-video-viewer-summary.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-creators-v2',
  standalone: true,
  imports: [TooltipDirective, ForYouCreatorsComponent, MagicFiltersComponent, 
    FilteredCreatorsComponent, MagicSearchbarV2Component, SearchedCreatorsComponent, 
    CollaboratorsComponent, CreatorProfileComponent, CreatorsForListComponent, SingleVideoViewerSummaryComponent],
  templateUrl: './creators-v2.component.html',
  styleUrl: './creators-v2.component.css'
})
export class CreatorsV2Component implements OnInit {

  /** Services */
  private route = inject(ActivatedRoute);
  public magicSearchService = inject(MagicSearchService);
  public collaboratorsService = inject(CollaboratorService);
  public socialScreeningService = inject(SocialScreeningService);
  /** Services - END */

  ngOnInit(): void {
    let brief_param = this.route.snapshot.paramMap.get('briefId');
    if (brief_param) {
      console.log('🔍🔍🔍 briefId: ', brief_param);
      this.collaboratorsService.briefId.set(brief_param);
      this.collaboratorsService.selectedCreators.set([]);
    } else {
      this.collaboratorsService.briefId.set(undefined);
      this.collaboratorsService.selectedCreators.set([]);
    }
  }

}
